import CONST from 'constants/app.constants';

export default function HotelInterceptor($httpProvider) {
    'ngInject';

        const hotelSearchUrl = CONST.apiUrl + '/hotels/Search';

        $httpProvider.interceptors.push(['userService', function(userService) {
            return {
                request: function(config) {
                    const {dateFormat} = userService.getRegionalSettings();

                    const _config = angular.copy(config);
                    if (_config.method === 'GET' && _config.url.indexOf(hotelSearchUrl) === 0) {
                        // TODO: Ask back-end to refactor to use ISO Date instead of MM/DD/YYYY HH:mm
                        _config.params.checkInDate
                            = moment(_config.params.checkInDate, dateFormat).format('MM/DD/YYYY');
                        _config.params.checkOutDate
                            = moment(_config.params.checkOutDate, dateFormat).format('MM/DD/YYYY');


                        if (_config.params.MaximumRadiusSelected) {
                            _config.params.MaximumRadius = _config.params.MaximumRadiusSelected.Key;

                            delete _config.params.MaximumRadiusSelected;
                        }
                    }
                    return _config;
                },
            };

        }]);
}



// WEBPACK FOOTER //
// ./src/app/modules/hotels/services/hotels.interceptor.js